import React from 'react';
import { Modal, Button } from 'reactstrap';
import { FormAppCode } from './FormAppCode';
import { DeleteAppCode } from './DeleteAppCode';
import { Dialog } from 'primereact/dialog';
import { dividerClasses } from '@mui/material';

export const ModalAppCode = (props) => {

    const {
        modal, modalTitle, toggle, method,
        validaciones,
        brands, machineModels, infoAnalytes, methods,
        id_brand, id_analyzer, id_machine_model, id_info_analyte, code, convertion_factor, array_methods_ids,
        handleInputChange, handleValueSelect, handleMethods, loading, metodosSelect,
        saveCreate, saveUpdate,
        validacionAnalyte, saveDelete
        //  saveUpdate, saveDelete
    } = props;
    //

    return (

        <Dialog
            visible={modal}
            onHide={toggle}
            blockScroll={true}
            modal={true}
            closable={false}
            maskClassName="custom-total-mask"
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">
                        <div className="Global-dialog-icon">
                            <i className="fa fa-image"></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                {modalTitle}
                            </div>
                        </div>
                    </div>
                </div>
            }
            draggable={false}
            className={`Global-dialog Global-dialog Global-blue Global-small-v22`}
            footer={
                <>
                    {
                        method === "create" && <Button
                            color="secondary"
                            size="sm"
                            className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                            onClick={saveCreate}
                        >
                            Crear nuevo
                        </Button>
                    }
                    {
                        method === "update" && <Button
                            color="secondary"
                            size="sm"
                            className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                            onClick={saveUpdate}
                        >
                            Editar
                        </Button>
                    }

                    <Button size="sm" color='danger' type="button" onClick={toggle}>
                        {"Cancelar"}
                    </Button>

                </>
            }

        >

            {
                method === "create"
                    ? <FormAppCode
                        button={"Crear nuevo"}
                        {...{
                            validacionAnalyte, brands, machineModels, infoAnalytes, methods,
                            id_brand, id_analyzer, id_machine_model, id_info_analyte, code, convertion_factor, array_methods_ids, metodosSelect,
                            toggle, loading, handleInputChange, handleValueSelect, handleMethods, validaciones, methodAction: saveCreate
                        }}
                    />
                    : (method === "update")
                        ? <FormAppCode
                            button={"Editar"}
                            {...{
                                validacionAnalyte, brands, machineModels, infoAnalytes, methods,
                                id_brand, id_analyzer, id_machine_model, id_info_analyte, code, convertion_factor, array_methods_ids, metodosSelect,
                                toggle, loading, handleInputChange, handleValueSelect, handleMethods, validaciones, methodAction: saveUpdate
                            }}
                        />
                        : <DeleteAppCode
                            {...{ toggle, loading, saveDelete }}
                        />
            }
        </Dialog>
    )
};
